import { useState } from 'react';
import { faChevronDown, faChevronUp, faGraduationCap } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Container, Row } from 'react-bootstrap';
import AwardInfoPanel from './awardInformationPanel';
import TrophyIcon from '../../../../../assets/images/noun-trophy-1860077 1.png';

const AwardsInfo = ({ awardDocs = [] }) => {
  const [showAll, setShowAll] = useState(false);
  const validAwards = Array.isArray(awardDocs) ? awardDocs : [];
  const visibleAwards = showAll ? validAwards : validAwards.slice(0, 2);

  return (
    <Container className="pt-2 awards-container">
      <Row>
        <Col>
          <h3 className="candidate-heading">
            Awards ({validAwards.length})
            <img src={TrophyIcon} alt="Trophy" className="profile-work-experience-nav-icon" />
          </h3>
        </Col>
      </Row>
      <Container>
        {visibleAwards.map((award, index) => (
          <AwardInfoPanel key={`award-${index}`} colorSeed={Math.random()} award={award}></AwardInfoPanel>
        ))}
      </Container>
      {validAwards.length > 2 && (
        <Row>
          <Col>
            <a
              className="awards-view-all"
              onClick={() => setShowAll((prev) => !prev)}
            >
              {showAll ? 'View Less' : 'View All'}&nbsp;
              <FontAwesomeIcon icon={showAll ? faChevronUp : faChevronDown} />
            </a>
          </Col>
        </Row>
      )}
    </Container>
  );
};

export default AwardsInfo;